<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="货物名称">
              <a-select
                showSearch
                v-model="queryParam.materielId"
                :filterOption="filterOption"
                placeholder="请选择"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
              >
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in materielSelect"
                  :key="index"
                  :value="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="装卸货点">
              <a-select
                showSearch
                v-model="queryParam.factoryLoadId"
                :filterOption="filterOption"
                placeholder="请选择"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
              >
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in factoryLoadSelect"
                  :key="index"
                  :value="item.id"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="运输类型">
              <a-select
                showSearch
                v-model="queryParam.transportType"
                placeholder="请选择"
                default-value="0"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
              >
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in transportTypeSelect"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24" class="float1">
            <span class="table-page-search-submitButtons float1">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航-->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :scroll="{ x: 1850 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>
    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="货物名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
          showSearch
          :filterOption="filterOption"
            ref="materielIdform"
            placeholder="请选择货物名称"
            v-decorator="['materielId',
            { initialValue: mdl.materielId, rules: [{ required: true, message: '货物名称'}]}]"
          >
            <a-select-option
              v-for="(item, index) in materielSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="装卸料口" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
          showSearch
          :filterOption="filterOption"
            ref="factoryLoadIdform"
            placeholder="装卸料口"
            v-decorator="['factoryLoadId',
            { initialValue: mdl.factoryLoadId, rules: [{ required: true, message: '装卸料口'}]}]"
          >
            <a-select-option
              v-for="(item, index) in factoryLoadSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="运输类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
          showSearch
          :filterOption="filterOption"
            ref="transportTypeform"
            placeholder="请选择运输类型"
            v-decorator="['transportType',
                { initialValue: mdl.transportType, rules: [{ required: true, message: '运输类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in transportTypeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="批次前缀" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input class='inputlock'
            name="batchPrefixform"
            placeholder="批次前缀"
            v-bind:disabled="diasabledInputPrefix"
            v-decorator="['batchPrefix',
            {  initialValue: mdl.batchPrefix , rules: [{ required: true, message: '批次前缀'}]}]"
            
          />
          <img :src="openeye" class="eye" alt="" @click="changeType()">
          <!-- <img src="/materielbatch/selectInput2.png" alt="" >  -->
        </a-form-item>
        <a-form-item label="批次序号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input
            placeholder="批次序号"
            v-decorator="['serialNo',
            { initialValue: mdl.serialNo , 
            rules: [{ required: true, message: '批次序号'},
                    { message: '只能是数字',  pattern:/^[0-9]*$/}
            ]}]"
          />
        </a-form-item>
        <a-form-item label="批次总量(吨)" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" class='main'>
          <a-input-number
            :min="0"
            :precision="5" 
            placeholder="批次总量"
            v-decorator="['batchQuantity',
            { initialValue: mdl.batchQuantity, rules: [{ required: true, message: '批次总量'},{pattern: /^\d+(\.\d+)?$/, message: '必须为数字且不为负数'}]}]"
            @change="handlesurplusQuantity"
          />
        </a-form-item>
        <a-form-item label="批次剩余量(吨)" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number
          :min="0"
          :precision="5"
            placeholder="批次剩余量"
            v-decorator="['surplusQuantity',
            { initialValue: mdl.surplusQuantity,rules: [{ required: true, message: '批次余量'},{pattern: /^\d+(\.\d+)?$/, message: '必须为数字且不为负数'}]}]"
            disabled="false"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { formatDate } from '@/utils/date'
import {
  materielBatchPage,
  materielBatchSave,
  materielBatchDelete,
  materielBatchUpdate,
  materielList,
  factoryLoadList,
  materielBatchNumber,
  materielAllList
} from '@/api/basic'
import storage from '@/utils/storage'
export default {
  name: 'materielBatch',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      mdl: {},
      diasabledInput: false,
      diasabledInputPrefix:true,
      batchPrefix: null,
      batchQuantityNow: null,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam1: {},
      
      // 表头
       openeye: 'materielbatch/suo1.png', //图片地址
   
      columns: [
        {
          title: '货物',
          dataIndex: 'materielName',
          width: '250px',
          fixed: 'left'
        },
        {
          title: '装卸货点',
          dataIndex: 'factoryLoadName',
          width: '200px'
        },
        {
          title: '运输类型',
          dataIndex: 'transportTypeName',
          width: '120px'
        },
        {
          title: '批次前缀',
          dataIndex: 'batchPrefix',
          width: '120px'
        },
        {
          title: '批次序号',
          dataIndex: 'serialNo',
          width: '150px'
        },
        {
          title: '批次总量(吨)',
          dataIndex: 'batchQuantity',
          width: '120px'
        },
        {
          title: '批次余量(吨)',
          dataIndex: 'surplusQuantity',
          width: '120px'
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      // 运输工具类型下拉
      transportTypeSelect: null,
      //装卸货点下拉
      factoryLoadSelect: null,
      //物料下拉
      materielSelect: null,
      
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return materielBatchPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },
      
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },

  created() {
    this.tableOption()
    //this.materielSelect()
    this.loadSelect()
  },
  methods: {

    
    // stateFormat(row,column){
    //  let userList = this.$store.getters.userList,
    // //  if (row.creatName === -1) {
    // //   return 'manager'
    // // } else  {
    // //   return userList[row.creatName].userName
    // // } 
    // },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    loadSelect() {
      //后台拉取装卸货点ID
      new Promise(resolve => {
        const data = factoryLoadList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.factoryLoadSelect = res
      })
      new Promise(resolve => {
        const data = materielAllList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.materielSelect = res
      })
      this.transportTypeSelect = this.$store.getters.codeList.basic_factory_load_port_transport_type
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
      this.diasabledInput = false
      this.diasabledInputPrefix=true
      this.openeye='materielbatch/suo.png'
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
      this.diasabledInput = true
      this.diasabledInputPrefix=false
      this.openeye=''
    },
    handleSelectChange1(value) {
      // 判断如果没选择过货物则直接拼接
      const batchPrefixformInput = null
      let materielIdform = value
      let factoryLoadIdform = this.$refs.factoryLoadIdform.value
      let transportTypeform = this.$refs.transportTypeform.value
      if (materielIdform != null) {
        if (factoryLoadIdform != null) {
          if (transportTypeform != null) {
            if (transportTypeform == '1') {
              this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform + 'TV'
            } else if (transportTypeform == '2') {
              this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform + 'TS'
            }
          } else {
            this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform
          }
        } else {
          this.mdl.batchPrefix = 'M' + materielIdform
        }
      }
      // 修改用户名输入框的值
      //batchPrefixformInput.dispatchEvent(event)
      // document.querySelector('input[name=batchPrefixform]').value(batchPrefixformInput)
    },
    handleSelectChange2(value) {
      // const batchPrefixformInput = document.querySelector('input[name=batchPrefixform]')
      let materielIdform = this.$refs.materielIdform.value
      let factoryLoadIdform = value
      let transportTypeform = this.$refs.transportTypeform.value
      if (materielIdform != null) {
        if (factoryLoadIdform != null) {
          if (transportTypeform != null) {
            if (transportTypeform == '1') {
              this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform + 'TV'
            } else if (transportTypeform == '2') {
              this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform + 'TS'
            }
          } else {
            this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform
          }
        } else {
          this.mdl.batchPrefix = 'M' + materielIdform
        }
      }
    },
    handleSelectChange3(value) {
      //const batchPrefixformInput = document.querySelector('input[name=batchPrefixform]')
      let materielIdform = this.$refs.materielIdform.value
      let factoryLoadIdform = this.$refs.factoryLoadIdform.value
      let transportTypeform = value
      if (materielIdform != null) {
        if (factoryLoadIdform != null) {
          if (transportTypeform != null) {
            if (transportTypeform == '1') {
              this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform + 'TV'
            } else if (transportTypeform == '2') {
              this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform + 'TS'
            }
          } else {
            this.mdl.batchPrefix = 'M' + materielIdform + 'L' + factoryLoadIdform
          }
        } else {
          this.mdl.batchPrefix = 'M' + materielIdform
        }
      }
    },
    handlesurplusQuantity(value) {
      if (this.diasabledInput) {
        this.mdl.surplusQuantity = value
      }
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        Object.assign(this.mdl, values)
        console.log(this.mdl)
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            materielBatchUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            materielBatchSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return materielBatchDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    changeType() {
       
        this.openeye = this.openeye == 'materielbatch/suo1.png' ? 'materielbatch/suo.png' : 'materielbatch/suo1.png';
        this.diasabledInputPrefix=this.diasabledInputPrefix==true ? false:true;
      },


    // handleBatchNumber() {
    //   materielBatchNumber(Object.assign({}, this.queryParam1)).then(res => {
    //     console.log(res.data)
    //     this.batchQuantityNow = res.data[0] //当前批次号 res.data[1] 上一批次号
    //     return res.data
    //   })
    // }
  }
}
</script>
<style lang="less" scoped>
.float1 {
  float: right;
}
// .main{
// 		margin-top: 1.365853rem;
// 		box-sizing: border-box;
// 		padding: 0.512195rem 0.341463rem;
// 		position: relative;
// 		input{
// 			width: 9.365853rem;
// 			height: 1.07317rem;
// 			border: 0.02439rem solid rgb(239,239,239);
// 			border-radius: 0.121951rem;
// 			box-sizing: border-box;
// 			padding-left: 0.268292rem;
// 			font-size: 0.441463rem;
// 			margin-bottom: 0.390243rem;
// 		}
		
// 	}

.eye{
			position: absolute;
	    left: 14.5rem;
			top: 0.3rem;
		}
</style>
